import React, {Fragment, useRef, useState, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const File: (props: any) => JSX.Element = (props: any) => {

    const input = useRef<HTMLInputElement>(null);
    const [fileCount, setFileCount] = useState<number>(0);
    const {label, required, name, multiple} = props;
    const empty = true

    const handleClick = () => {
        if(input && input.current)
            input.current.click();
    }

    const handleChange = () => {
        if(input && input.current && input.current.files) {
            const fileCount: number = input.current.files.length;
            setFileCount(fileCount);
        }
    }

    return (
        <Fragment>
            <div className={`flex flex-row items-center gap-5 w-[100%] transition-all cursor-pointer bg-white border-[1px] ${fileCount === 0 ? 'border-gray-500 text-gray-500' : 'border-grey-800 text-gray-800'}`} onClick={() => handleClick()} >
                <div className={`px-5 border-r-[1px] ${fileCount === 0 ? 'border-r-gray-300' : 'border-r-gray-500'}`} >
                    <FontAwesomeIcon icon={icon({name: 'file-arrow-up'})} />
                </div>
                <div className="py-3 flex flex-col gap-4">
                    {fileCount === 0 &&
                        <div>
                            {label ? label : 'Dateien hochladen'}
                        </div>
                    }
                    {fileCount !== 0 &&
                        <div className="text-green-500">
                            {`${fileCount > 1 ? `${fileCount } Dateien ausgewählt` : 'Eine Datei ausgewählt'}`}
                        </div>
                    }
                </div>
                <div className="hidden">
                    <input ref={input} type="file" name={name} required={required} multiple={multiple} onChange={() => handleChange()} />
                </div>
            </div>
        </Fragment>
    );
}

export default File;
